export default 'ai-skills-practice'
